<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
        <v-card-title>{{title}}</v-card-title>

        <v-card-text>
            <div 
                v-if="text != null"
                v-html="text"
            >
            </div>

            <v-combobox
                :label="label"
                :items="items"
                v-model="value"
                ref="my-cb"
            />
           
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                v-for="(action, index) in actions"
                :key="index"
                :color="action_color(index)"
                :disabled="disabled(index)"
                text
                @click="onAction(action)"
            >
            {{action.text}}
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,

            title: '',
            text: null,
            value: null,
            label: 'Select or enter a value',
            items: [],
            actions: [],
            on_ok: () => {},
            is_valid: null,
        }
    },

    created () {
        this.$event_bus.$on('combo_box_prompt', this.showDialog);
    },

    beforeDestroy () {
        this.$event_bus.$off('combo_box_prompt',this.showDialog);
    },

    methods: {

        showDialog(params)
        {
            this.title = params.title == null ? 'Select or enter a value' : params.title;
            this.text = params.text;
            this.items = params.items == null ? [] : params.items;
            this.label = params.label;
            this.value = params.value;
            this.after_prompt = params.after_prompt == null ? () => {} : params.after_prompt;
            this.actions = params.actions;

            this.is_valid = params.is_valid;
            if ( this.is_valid == null )
            {
                this.is_valid = (text) => {
                    if ( text == null ) return false;
                    return text.trim().length > 0;
                };
            }

            this.dialog = true;
        },

        isValid()
        {
            return this.is_valid(this.value);
        },

        action_color(index)
        {
            if ( index == this.actions.length -1 ) 
                return 'primary darken-1';
            
            return null;
        },

        disabled(index)
        {
            if ( index != this.actions.length -1 ) 
                return false;
            
            return !this.isValid();
        },

        onAction(action) 
        {
            this.$refs['my-cb'].updateSelf();

            this.dialog = false;

            if ( this.after_prompt != null && action.value != null )
            {
                this.after_prompt(this.value, action.value);
            }
        },

    },
}
</script>

<style lang="scss" scoped>
</style>